module.exports = __webpack_public_path__ + "static/img/solar-energy-05.651072a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/solar-energy/solar-energy-05.jpg
// module id = 32IU
// module chunks = 100